import {FormError} from './FormError.js'

export class SpecsFormError extends FormError {}
